const GameArt = ({ game }) => {
  const { from, to } = game.colors;
  const gid = `g-${game.id}`;

  if (game.art === "runner") {
    return (
      <svg viewBox="0 0 400 260" className="w-full h-full" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
        <defs>
          <linearGradient id={gid} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
          <radialGradient id={`${gid}-glow`} cx="0.5" cy="0.75" r="0.6">
            <stop offset="0%" stopColor={from} stopOpacity="0.4" />
            <stop offset="100%" stopColor={from} stopOpacity="0" />
          </radialGradient>
        </defs>
        <rect width="400" height="260" fill="#0F0F16" />
        <rect width="400" height="260" fill={`url(#${gid}-glow)`} />
        <line x1="0" y1="120" x2="400" y2="120" stroke={to} strokeWidth="1" opacity="0.3" />
        {[40, 130, 270, 360].map((x) => (
          <line key={x} x1={x} y1="260" x2="200" y2="120" stroke={`url(#${gid})`} strokeWidth="1.5" opacity="0.55" />
        ))}
        {[150, 175, 208, 248].map((y, i) => (
          <line
            key={y}
            x1={40 + i * 18}
            y1={y}
            x2={360 - i * 18}
            y2={y}
            stroke={to}
            strokeWidth="1.5"
            opacity={0.25 + i * 0.15}
          />
        ))}
        <circle cx="200" cy="196" r="20" fill={`url(#${gid})`} />
        <circle cx="193" cy="189" r="6" fill="#FFFFFF" opacity="0.75" />
        <rect x="262" y="150" width="14" height="34" rx="3" fill={to} opacity="0.6" />
        <rect x="120" y="128" width="10" height="22" rx="3" fill={from} opacity="0.55" />
      </svg>
    );
  }

  if (game.art === "focus") {
    return (
      <svg viewBox="0 0 400 260" className="w-full h-full" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
        <defs>
          <linearGradient id={gid} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
          <radialGradient id={`${gid}-glow`} cx="0.5" cy="0.5" r="0.6">
            <stop offset="0%" stopColor={from} stopOpacity="0.35" />
            <stop offset="100%" stopColor={from} stopOpacity="0" />
          </radialGradient>
        </defs>
        <rect width="400" height="260" fill="#0F0F16" />
        <rect width="400" height="260" fill={`url(#${gid}-glow)`} />
        {[86, 60, 34].map((r, i) => (
          <circle
            key={r}
            cx="200"
            cy="130"
            r={r}
            fill="none"
            stroke={`url(#${gid})`}
            strokeWidth={i === 2 ? 3 : 1.5}
            opacity={0.35 + i * 0.25}
            strokeDasharray={i === 0 ? "4 12" : undefined}
          />
        ))}
        <circle cx="200" cy="130" r="12" fill={`url(#${gid})`} />
        {[
          [200, 18],
          [200, 242],
          [88, 130],
          [312, 130],
        ].map(([x, y]) => (
          <line
            key={`${x}-${y}`}
            x1={x}
            y1={y}
            x2={200 + (x - 200) * 0.82}
            y2={130 + (y - 130) * 0.82}
            stroke={to}
            strokeWidth="2.5"
            opacity="0.7"
            strokeLinecap="round"
          />
        ))}
        {[
          [54, 48],
          [346, 52],
          [50, 212],
          [350, 210],
        ].map(([x, y]) => (
          <circle key={`d${x}-${y}`} cx={x} cy={y} r="4" fill={to} opacity="0.8" />
        ))}
      </svg>
    );
  }

  if (game.art === "cards") {
    return (
      <svg viewBox="0 0 400 260" className="w-full h-full" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
        <defs>
          <linearGradient id={gid} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
          <radialGradient id={`${gid}-glow`} cx="0.5" cy="0.5" r="0.6">
            <stop offset="0%" stopColor={from} stopOpacity="0.4" />
            <stop offset="100%" stopColor={from} stopOpacity="0" />
          </radialGradient>
        </defs>
        <rect width="400" height="260" fill="#0F0F16" />
        <rect width="400" height="260" fill={`url(#${gid}-glow)`} />
        {[-18, 18].map((rot) => (
          <g key={rot} transform={`rotate(${rot} 200 215)`}>
            <rect x="162" y="58" width="76" height="118" rx="10" fill="#15151F" stroke={`url(#${gid})`} strokeWidth="2" opacity="0.85" />
          </g>
        ))}
        <rect x="162" y="58" width="76" height="118" rx="10" fill="#15151F" stroke={`url(#${gid})`} strokeWidth="2.5" />
        <circle cx="200" cy="106" r="22" fill={`url(#${gid})`} />
        <circle cx="200" cy="106" r="14" fill="none" stroke="#0F0F16" strokeWidth="3" />
        <circle cx="200" cy="106" r="4" fill="#0F0F16" />
        <text x="200" y="163" textAnchor="middle" fontFamily="Unbounded, sans-serif" fontWeight="700" fontSize="16" fill={`url(#${gid})`}>7</text>
        {[
          [52, 46],
          [348, 52],
          [48, 214],
          [352, 208],
        ].map(([x, y]) => (
          <circle key={`${x}-${y}`} cx={x} cy={y} r="4" fill={to} opacity="0.8" />
        ))}
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 400 260" className="w-full h-full" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
      <defs>
        <linearGradient id={gid} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor={from} />
          <stop offset="100%" stopColor={to} />
        </linearGradient>
        <radialGradient id={`${gid}-glow`} cx="0.5" cy="0.5" r="0.6">
          <stop offset="0%" stopColor={to} stopOpacity="0.5" />
          <stop offset="100%" stopColor={to} stopOpacity="0" />
        </radialGradient>
      </defs>
      <rect width="400" height="260" fill="#0F0F16" />
      <rect width="400" height="260" fill={`url(#${gid}-glow)`} />
      {[70, 110, 150].map((r, i) => (
        <circle
          key={r}
          cx="200"
          cy="130"
          r={r}
          fill="none"
          stroke={`url(#${gid})`}
          strokeWidth="1.5"
          opacity={0.55 - i * 0.15}
          strokeDasharray={i === 1 ? "6 10" : undefined}
        />
      ))}
      <text
        x="200"
        y="185"
        textAnchor="middle"
        fontFamily="Unbounded, sans-serif"
        fontWeight="900"
        fontSize="150"
        fill={`url(#${gid})`}
      >
        ?
      </text>
      {[
        [60, 50],
        [340, 60],
        [50, 210],
        [350, 200],
      ].map(([x, y]) => (
        <circle key={`${x}-${y}`} cx={x} cy={y} r="4" fill={to} opacity="0.8" />
      ))}
    </svg>
  );
};

export default GameArt;
